import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import "./Common/CSS/skeleton.css";
import "./Common/CSS/pagination.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import GlobalStyle from "./Style";
import { AuthProvider } from "./Common/Components/AuthContext";
import { ToastProvider } from "./Common/Components/ToastProvider";
import queryClient from "./Common/queryClient";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ToastProvider>
      </QueryClientProvider>
    </AuthProvider>
    <GlobalStyle />
  </React.StrictMode>
);

reportWebVitals();
